import { createContext, PropsWithChildren, useContext, useMemo } from 'react'
import { AssistantClient, AssistantClientType } from './assistantClient.ts'
import { initDataType } from '../types/initDataTypes.ts'

export const EMPTY_CLIENT: AssistantClientType = { getCookie: async () => {} }
const ClientContext = createContext<AssistantClientType>(EMPTY_CLIENT)
export const useClient = () => useContext(ClientContext)

export function ClientProvider(
  props: PropsWithChildren<{
    endpoint: string
    initData: initDataType
  }>
) {
  const client = useMemo(() => {
    return new AssistantClient(props.endpoint, props.initData)
  }, [props.endpoint, props.initData])
  return (
    <ClientContext.Provider value={client}>
      {props.children}
    </ClientContext.Provider>
  )
}
